import {
  Button,
  Drawer,
  Skeleton,
  Checkbox,
  TreeSelect,
  Card,
  Spin,
  ConfigProvider,
  Radio,
  Space,
  Tag,
} from "antd";
import { useState, useEffect, useRef } from "react";
import { useStoreUpdaterWithAPI } from "../../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../../Common/APIConstants";
import CustomDrawer from "../../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../../Elements/CustomSelect";
import SteamTreeSelectCustomWithSelectAll from "../../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import SteamTreeSelectCustom from "../../../../../../Elements/TreeSelect/TreeSelectCustom";
import { calculateDateRangeFromDate } from "../../../../../../../Utils/DateConverstion";
import { useDispatch, useSelector } from "react-redux";
import * as echarts from "echarts";
import TreeSelectCustomWithSelectAll from "./TreeSelectCustomWithAllSelect";
import TreeSelectCustom from "../../LiveTrends/LineChart/TreeSelectCustom";
import {
  EnvironmentOutlined,
  FilterOutlined,
  // SunOutlined,
} from "@ant-design/icons";
import Empty from "../../../../../../CommonScreens/Empty";
import { setTheme } from "../../../../../../../Store/Reducers/ThemeAction";
import CustomThemeDrawer from "../../../../../../Elements/CustomThemeDrawer";
import { handledarkMode } from "../../../../../../Elements/DarkModeAction";
import { SunOutlined, MoonOutlined } from "@ant-design/icons";
import NotAuthenticated from "../../../../../../CommonScreens/NotAuthenicated";

const LiveChart = () => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const prevSeriesRef = useRef([]);
  const prevTimestampsRef = useRef([]);

  const { loading, makeRequest, screenNameChecker } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState();
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [openTheme, setOpenTheme] = useState(false);
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState();
  const [chartSkip, setChartSkip] = useState(true);

  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [chartLoading, setChartLoading] = useState(false);
  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState(
    []
  );
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] =
    useState([]);
  const [steamHistoricalData, setsteamHistoricalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [parameter, setParameter] = useState([]);
  const [data1, setData1] = useState([]);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [loadings, setLoadings] = useState(true);
  const [loadingss, setLoadingss] = useState(true);
  const [inputLiveData, setInputLiveData] = useState([]);
  const [defaultLoad, setDefaultLoad] = useState(true);
  const [legends, setLegends] = useState([]);
  const [moduleList, setModuleList] = useState([
    { id: 3, name: "Temperature" },
    { id: 6, name: "Gas" },
    { id: 5, name: "Air" },
    { id: 4, name: "Water" },
    { id: 2, name: "Steam" },
  ]);
  const [module, setModule] = useState(null);
  const [selectedValues, setSelectedValues] = useState([1]);
  const handleModuleChange = (value) => {
    // console.log(value);
    // console.log(selectedValues);
    setModule(value);
    setSectionId([]);
    setConverterGroupId(null);
    setSelectedMeterIds([]);
    // setSelectedValues([1]);
    //  if(value==3){
    //   setSelectedValues([1])
    // }else{
    //   setSelectedValues([4])

    // }

  };
  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 1000); // 2 seconds
  };
  useEffect(() => {
    simulateLoading(setLoadings);
  }, []);
  // useEffect(() => {
  //   // setSelectedValues(module==3?["temperature"]:["cumulative"])
  //   if(module==3){
  //     localStorage.setItem("LiveTrendsselectedValues", JSON.stringify([ 'temperature' ]));
  //   }else{
  //     localStorage.setItem("LiveTrendsselectedValues", JSON.stringify(["cumulative"]));
  //   }
  // }, [module]);

  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  const { isdarkMode } = mode;

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.FLOW_MODULES}`,
    }).then((res) => {
      //  console.log(res);
      if (res && res.length > 0) {
        setModuleList(res);
        setModule(res[0].moduleId)
      }
    });
  }, []);
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setflowSectionResData(res); 
        setSectionId(res[0]?.sectionID) 
      }
    }); 
  }, []);
  useEffect(() => {
    localStorage.setItem("LiveTrendssectionId", sectionId);
    localStorage.setItem("LiveTrendsconverterGroupId", converterGroupId);
    // setConverterGroupId(1);
    //  [ 'KWT', 'VLLAvg' ]
    localStorage.setItem("LiveTrendsselectedValues", JSON.stringify(selectedValues));
    return () => {
      // console.log("Component unmounted — clearing localStorage");
      localStorage.removeItem("LiveTrendsselectedMeterIds");
      localStorage.removeItem("LiveTrendssectionId"); 
      localStorage.removeItem("LiveTrendsconverterGroupId");
      localStorage.removeItem("LiveTrendsselectedValues");
    };
  }, [sectionId,converterGroupId,selectedValues]);
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      //http://124.123.65.25:92/SAWGConverterStatusDetails?ModuleType=2&FromDate=2025-09-26%2018%3A30%3A46.087&ToDate=2025-09-26%2018%3A30%3A46.087

      url:
        module == 3
          ? `${APIConstants.TEMP_CONVERTERS}?ModuleType=${module}`
          : `${APIConstants.FLOW_CONVERTERS}?ModuleType=${module}`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setgetFlowConverterResData(res);
         if(defaultLoad){
          setConverterGroupId(res[0]?.sitE_ID)
        }
      }
    });
  }, [sectionId]);
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.FLOW_PARAMETERS}?ModuleType=${module}`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setParameter(res);
        localStorage.setItem("LiveTrendsparameters", JSON.stringify(res||''));
          if(defaultLoad){
              setSelectedValues([res[0]?.parameterID])
        }
      }
    });
  }, [module]);

  useEffect(() => {
    if (sectionId == 2) {
      makeRequest({
        type: APIConstants.POST,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url:
          module == 1
            ? `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`
            : `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`,
      }).then((res) => {
        //  //console.log(res);
        if (res && res.length > 0) {
          setflowGroupDetailsResData(res);
        }
      });
    }
  }, [sectionId, module]);

  useEffect(() => {
    if (converterGroupId && sectionId == 1) {
      makeRequest({
        type: APIConstants.GET,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url:
          module == 1
            ? `${APIConstants.TEMP_METERS}?SiteID=${converterGroupId}&MeterType=${module}`
            : `${APIConstants.TEMP_METERS}?SiteID=${converterGroupId}&MeterType=${module}`,
      }).then((res) => {
        // console.log(res);
        if (res && res.length > 0) {
          if (defaultLoad) {
            const firstFiveMeters = res
              .slice(0, 5)
              .map((meter) => meter.meteR_METERID);

            //console.log(res.map((meter) => meter.meterid));
            // console.log(firstFiveMeters);
            setSelectedMeterIds(firstFiveMeters);
            localStorage.setItem("LiveTrendsselectedMeterIds", firstFiveMeters);
            setDefaultLoad(false);
          }
          setnsGetFlowConverterResData(res);
          localStorage.setItem(
            "LiveTrendsnsGetFlowConverterList",
            JSON.stringify(res)
          );
        }
      });
    }

    if (converterGroupId && sectionId == 2) {
      makeRequest({
        type: APIConstants.POST,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url:
          module == 1
            ? `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`
            : `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setgetFlowSteamGroupMeterResData(res);
        }
      });
    }
  }, [converterGroupId]);

  function transformDatas(inputData) {
    // Initialize arrays to store unique CreatedOn values and unique meter names
    const createdOn = [];
    const meterNames = [];

    // Collect unique CreatedOn values and meter names
    inputData.forEach((entry) => {
      const formattedDate = entry.CreatedOn.replace("T", " ");
      if (!createdOn.includes(formattedDate)) {
        createdOn.push(formattedDate);
      }
      if (!meterNames.includes(entry.METERNAME)) {
        meterNames.push(entry.METERNAME);
      }
    });

    // Initialize series array with meter names
    const series = meterNames.map((meterName) => ({
      name: meterName,
      type: "line",
      stack: "Total",
      data: Array(createdOn.length).fill(0), // Initialize with zeros for each CreatedOn value
    }));

    inputData.forEach((entry) => {
      const formattedDate = entry.CreatedOn.replace("T", " ");
      const dateIndex = createdOn.indexOf(formattedDate);
      const meterIndex = meterNames.indexOf(entry.METERNAME);

      if (dateIndex !== -1 && meterIndex !== -1) {
        series[meterIndex].data[dateIndex] += entry.KWHTotal;
      }
    });

    // Return the formatted structure
    return { series, createdOn, meterNames };
  }

  function prepareLineChartData19(
    data,
    excludeFields = ["SiteName", "MeterId", "CreatedOn", "METERNAME"]
  ) {
    const rawTimestamps = [];
    const metricsMap = {};
    const parameters = [];

    // Step 1: Normalize timestamps & collect all unique ones
    data.forEach((entry) => {
      const rawTime = entry.CreatedOn.replace("T", " ");
      const [date, time] = rawTime.split(" ");
      const timeWithoutSeconds = time.split(":").slice(0, 2).join(":");
      const normalizedTime = `${date} ${timeWithoutSeconds}:00`;

      rawTimestamps.push(normalizedTime);

      for (const key in entry) {
        if (!excludeFields.includes(key)) {
          const metricKey = `${entry.METERNAME}-${key}`;

          if (!metricsMap[metricKey]) {
            metricsMap[metricKey] = {};
          }

          // Store value for this metric at this timestamp
          metricsMap[metricKey][normalizedTime] = entry[key];

          parameters.push(key);
        }
      }
    });

    // Step 2: Unique & sorted timestamps
    const uniqueTimestamps = Array.from(new Set(rawTimestamps)).sort();

    // Step 3: Build aligned series
    const series = Object.entries(metricsMap).map(([metricName, valueMap]) => {
      const alignedData = uniqueTimestamps.map((ts) =>
        ts in valueMap ? valueMap[ts] : null
      );

      return {
        name: metricName,
        type: "line",
        data: alignedData,
      };
    });

    // Step 4: Deduplicate parameters
    const uniqueParameters = [...new Set(parameters)];

    return {
      xAxisData: uniqueTimestamps,
      series: series,
      parameter: uniqueParameters,
    };
  }

  function prepareLineChartData(
    data,
    toDate,
    fromDate,
    excludeFields = ["sitename", "meterid", "createdON", "metername"]
  ) {
    const series = [];
    const metrics = {};
    const parameters = [];

    // Normalize date string
    const normalizeDateString = (str) => {
      const parts = str.split("T");
      const [y, m, d] = parts[0].split("-");
      const paddedDate = `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
      return `${paddedDate}T${parts[1]}`;
    };

    const start = new Date(normalizeDateString(fromDate));
    const end = new Date(normalizeDateString(toDate));

    // Format timestamp (yyyy-mm-dd hh:mm:00)
    const formatTs = (date) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const hh = String(date.getHours()).padStart(2, "0");
      const mi = String(date.getMinutes()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd} ${hh}:${mi}:00`;
    };

    // Generate all timestamps
    const allTimestamps = [];
    let current = new Date(start);
    while (current <= end) {
      allTimestamps.push(formatTs(current));
      current.setMinutes(current.getMinutes() + 1);
    }

    // If data is empty, just return timestamps (no series)
    if (!data || data.length === 0) {
      return {
        xAxisData: allTimestamps,
        series: [], // ✅ no fake series
        parameter: [],
      };
    }

    // Process available data
    data.forEach((entry) => {
      const createdOn = new Date(entry.createdON);
      if (createdOn >= start && createdOn <= end) {
        const formattedTs = formatTs(createdOn);
        for (const key in entry) {
          if (!excludeFields.includes(key)) {
            const metricKey = `${entry.metername}-${key}`;
            if (!metrics[metricKey]) {
              metrics[metricKey] = {};
            }
            metrics[metricKey][formattedTs] = entry[key];
            parameters.push(key);
          }
        }
      }
    });

    // Build chart series
    for (const [metricName, valuesByTs] of Object.entries(metrics)) {
      const filledValues = allTimestamps.map((ts) => valuesByTs[ts] ?? "");
      series.push({
        name: metricName,
        type: "line",
        data: filledValues,
      });
    }

    return {
      xAxisData: allTimestamps,
      series,
      parameter: [...new Set(parameters)],
    };
  }

  // Converts object keys from CapitalCase/UPPERCASE to lowercase
  // and returns a clean array of formatted meter objects

  const transformMeterData = (data) => {
    if (!data || typeof data !== "object") return [];

    return Object.values(data).map((item) => {
      const transformed = {};

      Object.entries(item).forEach(([key, value]) => {
        const lowerKey = key.toLowerCase();

        // Normalize key names if needed
        switch (lowerKey) {
          case "sitename":
            transformed.sitename = value;
            break;
          case "meterid":
            transformed.meterid = value;
            break;
          case "metername":
            transformed.metername = value;
            break;
          case "createdon":
            transformed.createdON = value;
            break;
          case "cumulative":
            transformed.cumulative = value;
            break;
          case "flowrate":
            transformed.flowrate = value;
            break;
          case "temperature":
            transformed.temperature = value;
            break;
          case "rh":
          case "humidity":
            transformed.rh = value;
            break;
          case "pressure":
            transformed.pressure = value;
            break;
          default:
            transformed[lowerKey] = value;
        }
      });

      return transformed;
    });
  };

  const getResponse = (inputData) => {
    // console.log(inputData);
    //console.log(open);

    const url = `${APIConstants.TEMP_LIVE_CHART}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=${inputData.FromDate}&Todate=${inputData.ToDate}`;
    const url2 = `${APIConstants.FLOW_LIVE_CHART}?ModuleType=${module}&SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=${inputData.FromDate}&Todate=${inputData.ToDate}`;
    setIsLoading(true);
    if (
      inputData &&
      inputData?.SectionID &&
      inputData?.ConverterorGroupID &&
      inputData?.MeterIds &&
      inputData.MeterIds.length &&
      inputData.Parameters &&
      !open
    ) {
      makeRequest({
        type: APIConstants.GET,
        url: module == 3 ? url : url2,
      }).then((res) => {
        // console.log(res);
        // if (res && res.length > 0) {
        const response = transformMeterData(res);
        // console.log(response);
        setsteamHistoricalData(response);
        // const data = transformDatas(res);
        // //console.log(data);
        setData(response);
        // //console.log(data.meterNames);
        // setData1(data.createdOn)
        // setData2(data.series)
        // setData3(data.meterNames)
        const test = prepareLineChartData(
          response,
          inputData.ToDate.replace(".000Z", ""),
          inputData.FromDate.replace(".000Z", "")
        );
        // console.log(test);
        setData1(test.xAxisData);
        setData2(test.series);
        setLoadingss(false);
        setRefetch(true);
        // insertData(test.xAxisData, test.series)
        // setData3(test.parameter)
        // }
        setIsLoading(false);
      });
    }
  };

  useEffect(() => {
    if (inputLiveData) {
      getResponse(inputLiveData);
    }
  }, [inputLiveData]);

  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    localStorage.setItem("LiveTrendssectionId", changedValues);
    localStorage.setItem("LiveTrendsconverterGroupId", "");
    // localStorage.setItem("LiveTrendsselectedMeterIds", null);
    setSectionId(changedValues);
    setConverterGroupId(null);
    setSelectedMeterIds([]);
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    localStorage.setItem("LiveTrendsconverterGroupId", changedValues);
    localStorage.setItem("LiveTrendsselectedMeterIds", null);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    // //console.log(selectedValues)
    localStorage.setItem("LiveTrendsselectedMeterIds", selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    //console.log(values)
    localStorage.setItem("LiveTrendsselectedValues", JSON.stringify(values));

    if (values) {
      setParaError("");
    }
  };

  const setChartInputData = () => {
    // setOpen(false);
    const sectionId = localStorage.getItem("LiveTrendssectionId");
    // //console.log(sectionId);
    const converterGroupId = localStorage.getItem("LiveTrendsconverterGroupId");
    // //console.log(converterGroupId);
    const selectedValue = localStorage.getItem("LiveTrendsselectedValues");
    const parameter = localStorage.getItem("LiveTrendsparameters");
    // console.log(selectedValue);
    // console.log(parameter);
    // const para = JSON.parse(selectedValue)
    //   ?.map((id) => id)
    //   .join(",");

    const selectedMeterId = localStorage.getItem("LiveTrendsselectedMeterIds");
    const nsGetFlowConverterList = localStorage.getItem(
      "LiveTrendsnsGetFlowConverterList"
    );
    // console.log(selectedMeterId);
    // console.log(selectedMeterIds);
    // console.log(selectedMeterIds.join(','));
    let ids = [];
    // if(selectedMeterIds!=''&&selectedMeterIds!=null){
    //   ids = JSON.parse(selectedMeterIds||'1,2,3,4,5,6,7,8,9,10,11,12')
    //     ?.map((id) => id)
    //     .join(",");
    // }
    // //console.log(ids);
    // setSelectedMeterIds(JSON.parse(selectedMeterIds));
    // setSelectedValues(JSON.parse(selectedValue));

    sectionId == 1 ? nsGetFlowConverterList : getFlowSteamGroupMeterList;
    // console.log(selectedMeterIds);
    // console.log(JSON.parse(nsGetFlowConverterList));
    // console.log(getFlowSteamGroupMeterList);

    console.log(parameter)
    console.log(selectedValue)
    const para = (parameter!==''&&parameter!=null)?JSON?.parse(parameter)
      .filter((p) => JSON.parse(selectedValue).includes(p.parameterID))
      .map((p) => p.parameterName)
      .join(","):''
    console.log(para);
    const paramArr = para.split(",");

    // Build legends
    const legendsData = selectedMeterIds.flatMap((id) => {
      const meter =
        sectionId == 1
          ? JSON.parse(nsGetFlowConverterList).find(
              (m) => m.meteR_METERID == id
            )
          : getFlowSteamGroupMeterList.find((m) => m.meterid == id);
      return meter
        ? paramArr.map((p) => `${meter.metername}-${p.toLowerCase()}`)
        : [];
    });

    // console.log(legendsData);
    if (legendsData.length) {
      localStorage.setItem("legends", JSON.stringify(legendsData));
    }
    // console.log(legendsData.pop());
    // localStorage.setItem()
    setLegends(legendsData);
    const currentDate = new Date();
    // //console.log(currentDate);
    const { from, to } = calculateDateRangeFromDate(currentDate, 60, 0);
    // //console.log(from, to);

    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 0,
      Parameters: para || 0,
      MeterIds: selectedMeterId || selectedMeterIds.join(","),
      // FromDate: '2023-08-03 12:32:53',
      // ToDate: '2023-08-03 12:52:53',
      FromDate: from,
      ToDate: to,
    };
    console.log(inputData);
    setRefetch(true);
    setInputLiveData(inputData);
    // getResponse(inputData);
    // onClose()
    // const queryString = objectToQueryString(inputData);
    // setChartInput(queryString);
  };

  useEffect(() => {
    // Call the function every minute
    //console.log(refetch);
    const interval = setInterval(() => {
      // console.log(refetch);
      if (refetch) {
      }
      setChartInputData();
    }, 60000); // 60000 milliseconds = 1 minute

    // Cleanup the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setChartInputData();
  }, [defaultLoad]);
  useEffect(() => {
    setChartSkip(!chartSkip);
    // updateChart();
  }, [steamHistoricalData]);

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds?.length, "Meter");
    const paraError = validateInput(selectedValues?.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);
    //console.log(sectionError, converterError, meterError, paraError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError
      // && !parameterLenght
    ) {
      onClose();
      setChartLoading(true);
      setChartInputData();

      setIsLoading(!isLoading);
    }
  };
  useEffect(() => {
    if (loading || !data1 || !data2 || data1.length === 0) return;

    const chart = chartInstance.current || echarts.init(chartRef.current);
    chartInstance.current = chart;
    const legends = JSON.parse(localStorage.getItem("legends")) || [];
    // console.log(legends);

    // console.log(legends);
    // console.log(data2);
    // console.log(data1);
    const currentMeters = legends.map((s) => s);
    // console.log(currentMeters);
    const previousMeters = (prevSeriesRef.current || []).map((s) => s);
    // console.log(previousMeters);

    const removedMeters = previousMeters.filter(
      (m) => !currentMeters.includes(m)
    );
    const addedMeters = currentMeters.filter(
      (m) => !previousMeters.includes(m)
    );

    const themeColor = isdarkMode ? "#2d3748" : "#ffffff";
    const textColor = isdarkMode ? "#ffffff" : "#000000";

    const combinedTimestamps = data1.slice(-60);

    const baseOption = {
      backgroundColor: themeColor,
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "line",
          label: { show: true, backgroundColor: "#6a7985" },
        },
        backgroundColor: themeColor,
        textStyle: { color: textColor },
        confine: true,
        extraCssText: "box-shadow: 0 0 5px rgba(0,0,0,0.3);",
      },
      // legend: {
      //   top: "0px",
      // }
      toolbox: {
        show: true,
        feature: {
          saveAsImage: {
            show: true,
            title: "Download",
            pixelRatio: 2, // higher resolution
            name: "chart-image", // file name
          },
        },
      },
      legend: {
        textStyle: { color: textColor },
        type: "scroll",
        top: "0%",
        orient: "horizontal",
        left: "center", // Centers the legend
        itemGap: 10, // Adjust spacing between items
        padding: [5, 20], // Optional padding
        width: "80%", // Prevents it from taking full width
      },
      dataZoom: [
        // Horizontal zoom (bottom slider)
        {
          type: "slider",
          show: true,
          xAxisIndex: 0,
          start: 0,
          end: 100,
        },
        // Horizontal zoom (drag inside)
        {
          type: "inside",
          xAxisIndex: 0,
          start: 0,
          end: 100,
        },
        // ✅ Vertical zoom (right slider)
        {
          type: "slider",
          show: true,
          yAxisIndex: 0,
          start: 0,
          end: 100,
          right: 10, // optional: position slider from right
          width: 15, // optional: slider thickness
          orient: "vertical", // vertical orientation
        },
        // Vertical zoom (drag inside)
        {
          type: "inside",
          yAxisIndex: 0,
          start: 0,
          end: 100,
        },
      ],

      grid: {
        left: "3%",
        right: "4%",
        bottom: "15%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: combinedTimestamps,
          axisLabel: {
            color: textColor,
            fontSize: 10,
            fontWeight: "bold",
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          axisLabel: {
            color: textColor,
            fontSize: 10,
            fontWeight: "bold",
          },
        },
      ],
    };

    if (
      addedMeters.length > 0 ||
      removedMeters.length > 0 ||
      !prevSeriesRef.current.length
    ) {
      const fullSeries = data2.map((series) => ({
        ...series,
        data: series.data.slice(-60), // ✅ align with 15 timestamps
      }));
      // console.log(fullSeries);
      const dat = legends.map((meter) => {
        const found = fullSeries.find(
          (s) =>
            s.name.replace(/\s+/g, "").toLowerCase() ===
            meter.replace(/\s+/g, "").toLowerCase()
        );
        // console.log(found);
        return found ? found : { name: meter, type: "bar", data: [] };
      });

      // console.log(legends);
      // console.log(dat);

      chart.setOption({ ...baseOption, series: dat }, { notMerge: true });
    } else {
      const updatedSeries = data2.map((series) => ({
        ...series,
        data: series.data.slice(-60), //  only last 15 data points
      }));
      const dat = legends.map((meter) => {
        const found = updatedSeries.find((s) => s.name === meter);
        return found ? found : { name: meter, type: "bar", data: [] };
      });
      // console.log(legends);
      // console.log(dat);
      chart.setOption({
        xAxis: [{ data: combinedTimestamps }],
        series: dat,
        backgroundColor: themeColor,
      });
    }

    prevSeriesRef.current = JSON.parse(JSON.stringify(data2));
    prevTimestampsRef.current = [...combinedTimestamps];

    const resizeHandler = () => chartInstance.current?.resize();
    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, [data1, data2, loading, isdarkMode]);

  console.log(sectionId);
  console.log(getFlowConverterList)

  return (
    <div
      id="chart"
      className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? "darkmode" : "whitemode"} `}
    >
      <div className="flex justify-between items-center px-2">
        <div className="text-3xl">
          <h4
            className={`text-left text-[20px] md:text-[30px] mb-5 dark ${isdarkMode ? "darkfont" : "whitemode"}`}
          >
            LIVE TRENDS
          </h4>
        </div>
        <div className=" flex gap-5">
          <Tag className="animated-tag w-24 text-lg">
            <EnvironmentOutlined className="mr-1" />
            Live
          </Tag>
          {/* <Tag className="!text-green-400 rounded-xl !bg-transparent !border-green-400 w-20 text-center text-base flex justify-center items-center">
            <EnvironmentOutlined className="mr-2" />
            Live
          </Tag> */}
          <Button
            size="large"
            className="flex justify-center items-center secondary-btn"
            style={{
              "--secondary-color": color.themeConfig.secondaryColor,
              "--primary-color": color.themeConfig.colorPrimary,
            }}
            onClick={() => setOpen(true)}
          >
            <FilterOutlined /> Filter
          </Button>
        </div>
        {/* <Button
          role="primary"
          size="large"
          className="flex justify-center items-center "
          onClick={() => setOpen(!open)}
        >
          <FilterOutlined /> Filter
        </Button> */}
      </div>

      {
        !data1.length > 0 && !loading && (
          <Empty open={open} setOpen={setOpen} isdarkMode={isdarkMode} />
        )
        // <div className="text-3xl">
        // <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
        // </div>
      }
      <Card
        className={`p-4 rounded-md shadow dark ${isdarkMode ? "darkmode" : "whitemode  "} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        style={{
          position: "relative",
          overflow: "hidden",
          // background: isdarkMode ? "" : color.themeConfig.colorPrimaryShade,
        }}
        bordered={false}
      >
        {loading && loadings && (
          <>
            <Skeleton active paragraph={{ rows: 6 }} />
          </>
        )}
        <div
          ref={chartRef}
          className={`${(!loading || !loadings) && data1.length > 0 ? "min-h-[80vh]" : "h-0"}  w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}
        />
      </Card>

      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Module :"
            options={moduleList}
            onSelect={handleModuleChange}
            valueKey={"moduleId"}
            nameKey={"moduleName"}
            selectedValues={module}
          />
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
            selectedValues={sectionId || undefined}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "department"}
            // valueKey={sectionId === 1 ? "siteID" : "groupID"}
            // nameKey={sectionId === 1 ? "siteName" : "department"}
            selectedValues={converterGroupId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <TreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId == 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={"meteR_METERID"}
            valueKey={"meteR_METERID"}
            nameKey={"metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <TreeSelectCustom
            label="Parameters:"
            data={parameter}
            idKey="parameterID"
            nameKey="parameterName"
            valueKey="parameterID"
            selectedValues={selectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
            {/* {parameterLenght} */}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            type="primary"
            className=""
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default LiveChart;
